import axios from "axios";
import config from "../config/config";
import utilities from "../utils/utils";



let connector = {
    getNewAssessmentId: async () => {
        axios.get(`${config.baseUrl}/assessments`)
            .then(response => {
                localStorage.setItem('assessmentId', response.data.assessmentId);
            })
            .catch(error => {
                console.error('There was an error fetching the assessment ID!', error);
            });
    },
    getQuestions: async (category) => {
        return axios.get(`${config.baseUrl}/questions/?cat=${category}`, {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('There was an error fetching the questions!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    getQuestionById: async (id) => {
        return axios.get(`${config.baseUrl}/questions/${id}`, {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('There was an error fetching the question!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    getAnswerById: async (id) => {
        return axios.get(`${config.baseUrl}/responses/response/${id}`, {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('There was an error fetching the answer!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    getResponseById: async (id) => {
        console.log('Fetching response by passed id:', id);
        return axios.get(`${config.baseUrl}/responses/response/${id}`, {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('There was an error fetching the response!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    getResponsesByQuestionId: async (id) => {
        let responses = [];
 
        return axios.get(`${config.baseUrl}/questions/${id}`, {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then(async (response) => {
                // return response.data;
                for (let i = 0; i < response.data.fields.responses.length; i++) {
                    const responseId = response.data.fields.responses[i];
                    const res = await axios.get(`${config.baseUrl}/responses/response/${responseId}`);
                    responses.push(res.data);
                    

                }
                 responses = responses.filter(resp => {
                    return resp.fields['Assessment'] && resp.fields['Weighted (from Assessment)'].includes('true');
                 });

                //  console.log('all responses', responses);

                const responsesCount = responses.reduce((acc, resp) => {
                    const labels = resp.fields["Label (from Answers)"];
                  
                    if (!Array.isArray(labels)) return acc;
                  
                    labels.forEach(label => {
                      acc[label] = (acc[label] || 0) + 1;
                    });
                  
                    return acc;
                  }, {});

                  return responsesCount;
            })
            .catch(error => {
                console.error('There was an error fetching the question responses!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    getAssessmentById: async (id) => {
        return axios.get(`${config.baseUrl}/admin/assessment/${id}`, {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('There was an error fetching the assessment!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    getCategoricalScores: async (ids) => {
        return axios.post(`${config.baseUrl}/assessmentresults/getcategoricalscores`, {
            ids: ids
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('There was an error fetching the categorical scores!', error);
                throw error; // Re-throw the error for further handling if needed
            });
        // return response.data;
    },
    getCategoryMaximums: async () => {
        return await axios.get(`${config.baseUrl}/assessmentresults/getcategorymaximums`).then(response => {
            return response.data;
        })
            .catch(error => {
                console.error('There was an error fetching the category maximums!', error);
                throw error; // Re-throw the error for further handling if needed
            });
        // return response.data;
    },
    postAnswers: async (answers, assessmentId, scoresData) => {
        return await axios.post(`${config.baseUrl}/assessmentresults/postanswers`, {
            assessmentId: assessmentId,
            responses: answers,
            email: localStorage.getItem('userEmail') || '',
            browserName: utilities.getBrowserInfo().browserName,
            browserVersion: utilities.getBrowserInfo().fullVersion,
            deviceType: utilities.getBrowserInfo().deviceType,

            totalScore: scoresData['Total Score'],
            peopleScore: scoresData.People,
            policyScore: scoresData.Policy,
            technologyScore: scoresData.Technology,
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('There was an error posting the answers!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    sendEmail: async (email, webPageOrPdf) => {
        return await axios.post(`${config.baseUrl}/assessmentresults/sendemail`, {
            email: email,
            assessmentId: localStorage.getItem('assessmentId'),
            webPageOrPdf: webPageOrPdf
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('There was an error sending the email!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    authenticateAdminCode: async (code) => {
        return await axios.post(`${config.baseUrl}/admin/authenticate`, {
            code: code
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('There was an error authenticating the admin code!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    fetchGradebookData: async () => {
        return await axios.get(`${config.baseUrl}/admin/gradebook`, {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('There was an error fetching the gradebook data!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    fetchSingleAssessmentData: async (id) => {
        return await axios.get(`${config.baseUrl}/admin/assessment/${id}`, {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then(response => {

                return response.data;
            })
            .catch(error => {
                console.error('There was an error fetching the gradebook data!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    updateAssessmentFields: async (id, fields) => {
        console.log('updating assessment', id, fields);
        return await axios.post(`${config.baseUrl}/admin/updateassessment/${id}`, {
            fields: fields
        })
            .then(response => {

                return response.data;
            })
            .catch(error => {
                console.error('There was an error updating the assessment data!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    isEmailDisposable: async (email) => {
        return await axios.get(`https://www.disify.com/api/email/${email}`, {
            headers: {
                // 'Access-Control-Allow-Origin': '*'
            }
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('There was an error checking the email!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    handleAssessmentSubmission: async (assessmentId, email) => {
        let returnData = {};

        return connector.getCategoricalScores(utilities.getSavedAnswersIds())
            .then(data => {
                returnData.scores = data;
                // console.log("Categorical scores data:", data);
                return connector.postAnswers(utilities.getFullSurveyResponses(), assessmentId, data);
            })
            .then(scoresData => {
                returnData.assessmentData = scoresData;
                // console.log("returnData", returnData);
                return connector.fetchGradebookData();
            }).then(gradebookData => {
                returnData.totalsAndAverages = utilities.getWeightedScores(gradebookData);
                return returnData
            })
            .catch(error => {
                console.error("Error in handleAssessmentSubmission:", error);
                throw error;
            });
    },
    addEmailToAssessment: async (assessmentId, email) => {

        try {
            const response = await axios.post(`${config.baseUrl}/assessmentresults/addemail`, {
                assessmentId,
                email
            });

            return response.data;
        } catch (error) {
            console.error('There was an error adding the email to the assessment!', error);
            throw error; // bubble up if needed
        }
    },
    fetchCountries: async () => {
        return await axios.get(`https://restcountries.com/v3.1/all?fields=name,flags`)
            .then(response => {
                // console.log('countries response', response.data);
                const countries = response.data.map(country => country.name.common).sort();
                return countries;
            })
            .catch(error => {
                console.error('There was an error fetching the countries!', error);
                throw error; // Re-throw the error for further handling if needed
            });
    },
    addCityGeographicalInfo: async (assessmentId, city, state, country) => {
        console.log('Adding city geographical info to assessment:', assessmentId, city, state, country);

        try {
            const response = await axios.post(`${config.baseUrl}/assessmentresults/addcityinfo`, {
                assessmentId,
                city,
                state,
                country
            });

            return response.data;
        } catch (error) {
            console.error('There was an error adding the city geographical info to the assessment!', error);
            throw error; // bubble up if needed
        }
    },
    getTopicsScoresByAssessmentId: async (id) => {
        console.log('getTopicsScoresByAssessmentId called with id:', id);
        let fetchedTopicScore = await axios.get(`${config.baseUrl}/assessmentresults/topics-scores/${id}`)
            console.log(`this is the id passed to getTopicsScoresByAssessmentId: ${id}`);
            console.log('fetchedTopicScore', fetchedTopicScore);
            return fetchedTopicScore.data;
      
            
    },
    getTopicMaximums: async () => {
        return await axios.get(`${config.baseUrl}/topic-maxes`).then(response => {
            return response.data;
        })
            .catch(error => {
                console.error('There was an error fetching the topic maximums!', error);
                throw error; // Re-throw the error for further handling if needed
            });

        }
}

export default connector;